import { useUpdateCartStep } from '@hub/api/mutations';
import { CartStep } from '@monorepo/types';

export const useCartStep = () => {
  const updateCartStepMutation = useUpdateCartStep();

  const updateStep = (cartStep: CartStep) => {
    updateCartStepMutation.mutate(cartStep);
  };

  return {
    updateStep,
    isLoading: updateCartStepMutation.isPending,
    error: updateCartStepMutation.error,
  };
};
